import { Link } from 'react-router-dom'
import { Box, Typography } from '@mui/material'

export function AuthLogo() {
  return (
    <Box
      component={Link}
      to="/"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2.5,
        width: '100%',
        mb: 4,
        py: 2,
        textDecoration: 'none',
        color: 'primary.main',
        transition: 'transform 0.3s ease',
        '&:hover': {
          transform: 'scale(1.05)',
        },
      }}
    >
      <Box
        component="img"
        src="/icon/android-chrome-192x192.png"
        alt="EASYA"
        onError={(e) => {
          const target = e.target as HTMLImageElement
          target.src = '/icon/apple-touch-icon.png'
        }}
        sx={{
          width: { xs: 80, sm: 96 },
          height: { xs: 80, sm: 96 },
          objectFit: 'contain',
        }}
      />
      <Typography
        variant="h3"
        component="span"
        sx={{
          fontWeight: 900,
          letterSpacing: '-1px',
          fontSize: { xs: '2rem', sm: '2.75rem', md: '3rem' },
          lineHeight: 1.2,
        }}
      >
        EASYA
      </Typography>
    </Box>
  )
}
